import { FormContainer, LabeledInput, Worksheet } from "uikit"
import React from "react"
import { Dropdown, Grid } from "semantic-ui-react"
import { useStore } from "store"
import { AddPersonModal } from "../../../people/AddPersonModal"
import ConnectedAccountBar from "../../ConnectedAccountBar"
import { Footer } from "./Footer"

const ESAForm = ({
  data: {
    fields: { balance, beneficiary_id, basis },
    isModified,
    onSubmit,
    error
  },
  submitLabel = "Done",
  beneficiaryOptions,
  isNew,
  onDelete,
  addNewPerson,
  lastUpdatedAt,
  account
}) => {
  return (
    <Grid>
      {account.connection_id ? (
        <Grid.Row style={{ borderBottom: "1px solid #ccc" }}>
          <Grid.Column>
            <ConnectedAccountBar {...account} />
          </Grid.Column>
        </Grid.Row>
      ) : null}
      <Grid.Row>
        <Grid.Column>
          <Worksheet error={error} style={{ borderTop: "1px solid #ccc" }}>
            <Worksheet.Body>
              <Worksheet.Row
                label="What's the current balance in the account?"
                description={
                  account.connection_id
                    ? "Automatically updated through the account connection"
                    : null
                }
                paddedField
              >
                <Worksheet.Field error={balance.error}>
                  <LabeledInput
                    {...balance}
                    label=""
                    iconText="$"
                    iconPosition="left"
                    disabled={!!account.connection_id}
                    placeholder="0"
                    data-testid="balance"
                  />
                  {lastUpdatedAt}
                </Worksheet.Field>
              </Worksheet.Row>
              <Worksheet.Row
                label="Who's the beneficiary of the account?"
                paddedField
              >
                <Worksheet.Field error={beneficiary_id.error}>
                  <Dropdown
                    {...beneficiary_id}
                    placeholder="Beneficiary"
                    options={beneficiaryOptions}
                    search
                    selection
                    data-testid="accountOwner"
                  />
                  {beneficiary_id.value === "__ADD__" && (
                    <AddPersonModal
                      submit={personValues =>
                        addNewPerson(personValues).then(({ personId }) =>
                          beneficiary_id.onChange(null, { value: personId })
                        )
                      }
                      onCancel={() =>
                        beneficiary_id.onChange(null, { value: null })
                      }
                    />
                  )}
                </Worksheet.Field>
              </Worksheet.Row>
              <Worksheet.Row
                label="How much have you contributed to this account? (optional)"
                description="Your total contributions over the years, not including subsequent investment gains on those contributions."
                paddedField
              >
                <Worksheet.Field error={basis.error}>
                  <LabeledInput
                    {...basis}
                    label=""
                    iconText="$"
                    iconPosition="left"
                    placeholder="0"
                    data-testid="basis"
                  />
                </Worksheet.Field>
              </Worksheet.Row>
            </Worksheet.Body>
            <Footer
              isNew={isNew}
              submitLabel={submitLabel}
              onSubmit={onSubmit}
              onDelete={onDelete}
              isModified={isModified}
              deleteLabel={
                account.connection_id ? "Ignore Account" : "Delete Account"
              }
              hasConnectionId={account.connection_id ? true : false}
              error={error}
            />
          </Worksheet>{" "}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

const ESAFormContainer = FormContainer(
  {
    balance: {
      type: "unit",
      required: true
    },
    beneficiary_id: {
      type: "string",
      required: true
    },
    basis: {
      type: "unit",
      required: false
    }
  },
  (fields, ...form) => {}
)(ESAForm)

const ESA = ({ household, account, ...formProps }) => {
  const isNew = account == null
  const [people, { addPerson }] = useStore("householdPeople", household.id)
  const beneficiaryOptions = Object.values(
    people
  ).map(({ id: value, first_name: text }) => ({ value, text }))
  const canAddBeneficiary = true
  const defaultOwnerId =
    beneficiaryOptions.length === 1 ? beneficiaryOptions[0].value : ""
  const values = isNew ? { person_id: defaultOwnerId } : account
  if (canAddBeneficiary) {
    beneficiaryOptions.push({ text: "Add Beneficiary", value: "__ADD__" })
  }
  const addNewPerson = values =>
    addPerson({ household_id: household.id, ...values })
  return (
    <ESAFormContainer
      {...formProps}
      beneficiaryOptions={beneficiaryOptions}
      values={values}
      addNewPerson={addNewPerson}
      account={values}
    />
  )
}

export default ESA
